/* UNIMART: sticky-scroller devre dışı — filtre çubuğu artık saf CSS ile
   sticky + içeride kaydırılabilir (facets.css'teki kurallar hallediyor).
   Eski JS scroll'u ele geçirip üst kısmı erişilemez bırakıyordu. */
if (!customElements.get('sticky-scroller')) {
  class StickyScroller extends HTMLElement {}
  customElements.define('sticky-scroller', StickyScroller);
}